import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';
import { WS_STATUS, type WsTone } from './tokens';

export interface StatusChipProps extends Omit<ChipProps, 'color' | 'variant' | 'label'> {
  /** Always text: status is never carried by colour alone. */
  label: string;
  tone?: WsTone;
}

/**
 * A filled chip in one of the measured Material 3 status pairs (DESIGN.md).
 *
 * The fill and ink always come from the same pair, which is what keeps the contrast the
 * tokens advertise. There is no `color` prop: a screen picks a meaning, not a hue.
 */
export function StatusChip({ tone = 'neutral', label, sx, ...rest }: StatusChipProps) {
  const pair = WS_STATUS[tone];
  return (
    <Chip
      size="small"
      label={label}
      {...rest}
      sx={[{ backgroundColor: pair.fill, color: pair.ink }, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
}
